// extracted by mini-css-extract-plugin
module.exports = {"label":"Section_label__KRvw6","scale":"Section_scale__Y_7G_"};